import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';
import { LoginService } from '../services/login.service';
import { environment } from 'src/environments/environment.prod';
import { NgxSpinnerService } from 'ngx-spinner';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-login-in',
  templateUrl: './login-in.component.html',
  styleUrls: ['./login-in.component.css'],
  providers: [LoginService]
})
export class LoginInComponent {
  errorShow: boolean = false;
  errorShowDeactive: boolean = false;

  errorExpired: boolean = false;
  _dir = "";
  ngOnInit() {

  }
  constructor(private http: HttpClient,
    private spinner: NgxSpinnerService,
    // private userService : UserService,
    private loginService: LoginService,
    private router: Router, public translate: TranslateService
    , @Inject(DOCUMENT) private document: Document) {



    var _language = localStorage.getItem('_Language');
    var _dir = localStorage.getItem('_dir');

    environment.Language = _language;
    environment.dir = _dir;

    translate.use(environment.Language);
    this._dir = environment.dir;
  }

  OnSubmit(userName, password) {

    if (userName == "" || password == "" || userName == null || password == null || userName == undefined || password == undefined) {
      this.errorShow = true;
    }
    else {

      this.spinner.show();
      this.loginService.userAuthentication(userName, password)
        .subscribe((data: any) => {
          this.spinner.hide();
          if (data.Status == 404) {
            this.errorShow = true;
          }
          else if (data.Status == 420) {
            this.errorShowDeactive = true;
          }
          else if (data.Status == 421) {
            this.errorExpired = true;
          }
          else if (data.Status == 1) {

            sessionStorage.setItem('rootScope', JSON.stringify(data));
            sessionStorage.setItem('rootScopeLocation', JSON.stringify(data.Locations[0]));
            debugger
            environment.rootScope = data;
            environment.LocationSelected = data.Locations[0];
            //set token
            localStorage.setItem('token', data.Locations[0].Session);
            var _language = localStorage.getItem('_Language');
            var _dir = localStorage.getItem('_dir');
            if (_language == null || _language == "") {
              localStorage.setItem('_Language', "en");
              environment.Language = "en";
            } else {
              environment.Language = _language;
            }
            if (_dir == null || _dir == "") {
              localStorage.setItem('_dir', "ltr");
              environment.dir = "ltr";
            } else {
              environment.dir = _dir;
            }
            environment.Currency = environment.LocationSelected.Currency;

            // Set Odoo settings dynamically from  data
            if (environment.rootScope.User.IsOdoo !== undefined && environment.rootScope.User.IsOdoo !== null) {
              environment.IsOdoo = environment.rootScope.User.IsOdoo;
            }
            
            if (environment.rootScope.APIKeyOdoo != null) {
              environment.OdooApiKey =environment.rootScope.APIKeyOdoo ;
            }
          

            this.router.navigate(['/dashboard']);
          }
          console.log(data);
        },
          (err: HttpErrorResponse) => {
            console.log(err)
          });
    }
  }
}
